module.exports = __webpack_public_path__ + "img/electronicos.00adf403.png";